import PropTypes from 'prop-types'
import React, { Component } from 'react'

class NovaToggle extends Component {
  static defaultProps = {
    iconPosition: 'left',
    size: 'medium'
  };

  static propTypes = {
    id: PropTypes.string.isRequired,
    iconPosition: PropTypes.oneOf(['left', 'right']),
    size: PropTypes.oneOf(['small', 'medium', 'large'])
  };

  containerRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = { isOpen: false };
    this.toggleOpen = this.toggleOpen.bind(this);
  }

  toggleOpen() {
    this.setState(prevState => ({ isOpen: !prevState.isOpen }));
  }

  render = () => {
    const { children, id, iconPosition, size, ...props } = this.props
    const { isOpen } = this.state

    return (
      <div
        ref={this.containerRef}
        data-id={id}
        data-sprk-toggle='container'
        data-nova-icon-position={iconPosition}
        data-nova-size={size}
        {...props}
      >
        {React.Children.map(children, child => {
          if (React.isValidElement(child)) {
            return React.cloneElement(child, {
              iconPosition,
              size,
              isOpen,
              onToggle: this.toggleOpen,
              ...child.props
            })
          }
          return child
        })}
      </div>
    )
  };
}

export default NovaToggle
